export function offHoursNotice(
  time: string,
  professional: { id: string; displayName: string },
  warning: string,
  /// O nome do feriado do dia, quando o aviso é dele (ADR 0087).
  holiday = 'feriado',
): string {
  if (warning.startsWith('Sobreposição de horário:')) {
    const [overlap, ...other] = warning.split(' · ');
    return `${time}: ${overlap}. Você pode agendar assim; confira a organização dos atendimentos.${other.length ? ' ' + offHoursNotice(time, professional, other.join(' · '), holiday) : ''}`;
  }
  // Feriado avisa sem impedir, como o expediente: a empresa decide e responde pelo que marca.
  if (warning === 'feriado')
    return `${holiday}: a empresa não abre neste dia. Se agendar às ${time}, o atendimento fica marcado mesmo assim.`;
  if (warning === 'folga no feriado')
    return professional.id === 'ANY'
      ? `${holiday}: ninguém que realiza este serviço trabalha neste dia. Se agendar às ${time}, a agenda escolhe um deles mesmo assim.`
      : `${holiday}: ${professional.displayName} não está na equipe do dia. Se agendar às ${time}, o atendimento fica com ${professional.displayName} mesmo assim.`;
  if (warning === 'fora do horário do feriado')
    return `${holiday}: ${time} fica fora do horário do dia. Se agendar, o atendimento fica marcado mesmo assim.`;
  if (warning === 'sala fechada no feriado')
    return `${holiday}: a sala não funciona neste horário. Se agendar, o atendimento fica nessa sala mesmo assim.`;
  // Diz quem atende: o profissional escolhido mesmo, ou, com qualquer profissional, um dos que
  // realizam o serviço e estão livres — a API prefere quem está no expediente (ADR 0074).
  const name = professional.displayName;
  if (professional.id === 'ANY') {
    const where =
      warning === 'não atende neste dia'
        ? `Nenhum profissional que realiza este serviço atende neste dia. Se agendar às ${time},`
        : `${time} fica fora do expediente de todos os profissionais que realizam este serviço. Se agendar,`;
    return `${where} a agenda escolhe um deles que esteja livre, e o atendimento fica fora do expediente dessa pessoa.`;
  }
  if (warning === 'não atende neste dia')
    return `${name} não atende neste dia. Se agendar às ${time}, o atendimento fica com ${name} mesmo, fora do expediente.`;
  if (warning === 'fora do expediente')
    return `${time} fica fora do expediente de ${name}. Se agendar, o atendimento fica com ${name} mesmo, fora do expediente.`;
  return `${time} fica fora do expediente da sala. Se agendar, o atendimento fica nessa sala mesmo, fora do expediente dela.`;
}
